var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 751.741,
    height: 780.557,
    viewBox: "0 0 751.741 780.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.186,
    y1: 1.15,
    x2: 0.736,
    y2: -0.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 621.86,
    height: 573.648,
    rx: 191,
    transform: "translate(539.053) rotate(70)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle12);
export default __webpack_public_path__ + "static/media/Rectangle 12.05553ca5664e33f84bea414783d4873a.svg";
export { ForwardRef as ReactComponent };